import { forwardRef, type ReactNode } from 'react'
import { CloseIcon } from '../../../../../icons/CloseIcon'
import * as Dialog from '@radix-ui/react-dialog'

type DialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger?: ReactNode
  title: string
  description?: string
  children: ReactNode
}

export const DialogNew = forwardRef<HTMLDivElement, DialogProps>(
  ({ open, onOpenChange, trigger, children, title, description }: DialogProps, forwardRef) => {
    return (
      <Dialog.Root open={open} onOpenChange={onOpenChange} modal={true}>
        <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 z-[6] bg-black/40" />
          <Dialog.Content
            ref={forwardRef}
            className="fixed left-1/2 top-1/2 min-w-[250px] max-w-[650px] w-[90vw] z-[7] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white  shadow-soft overflow-hidden"
          >
            <div className="max-h-[650px] overflow-y-auto p-4 sm:p-6">
              <div className="flex w-full justify-between mb-6">
                <div className="flex flex-col gap-2">
                  <Dialog.Title className="text-lg font-semibold">{title}</Dialog.Title>
                  <Dialog.Description className="text-md font-normal text-secondaryText">
                    {description}
                  </Dialog.Description>
                </div>
                <Dialog.Close asChild>
                  <button
                    type="button"
                    onClick={() => onOpenChange(false)}
                    className="flex items-center justify-center h-10 w-10 rounded-full hover:bg-grayDark"
                  >
                    <CloseIcon />
                  </button>
                </Dialog.Close>
              </div>
              {children}
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    )
  },
)
